<template>
  <div class="cardItem">
    <div class="name">
      {{
        {
          1: "月卡",
          2: "周卡",
        }[props.cardItem.category]
      }}·{{
        {
          1: "尊享版",
          2: "经济版",
          3: "夜间版",
        }[props.cardItem.validTime]
      }}
    </div>
    <div class="time">
      有效期：{{ dayjs(props.cardItem.cardStartTime).format("YYYY-MM-DD") }}至
      {{ dayjs(props.cardItem.cardEndTime).format("YYYY-MM-DD") }}
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import dayjs from "dayjs";
// props
const props = defineProps({
  cardItem: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>

<style scoped lang="scss">
.cardItem {
  width: 84.54vmin;
  background: #e8f1fe;
  border-radius: 2.67vmin;
  border: 1px solid #d7e8fd;
  margin-left: 5.87vmin;
  padding-left: 3.73vmin;
  margin-bottom: 3.2vmin;
  .name {
    font-weight: 500;
    font-size: 3.73vmin;
    color: #10275b;
    line-height: 5.33vmin;
    padding-top: 4vmin;
    padding-bottom: 1.33vmin;
  }
  .time {
    font-weight: 400;
    font-size: 3.2vmin;
    color: #8793ad;
    line-height: 4.53vmin;
    padding-bottom: 3.73vmin;
  }
}
</style>
